import { InvoiceLine } from "./InvoiceType";

export default function SystemInvoiceItem({ item }: { item: InvoiceLine }) {
  const net = item?.wartosc_netto
    ? Number(item?.wartosc_netto)
    : Math.round(Number(item?.wartosc_brutto) / (1 + Number(item?.stawka_vat) / 100) * 100) / 100;

  const gross = item?.wartosc_brutto
    ? Number(item?.wartosc_brutto)
    : Math.round(Number(item?.wartosc_netto) * (1 + Number(item?.stawka_vat) / 100) * 100) / 100;

  const i = {
    lp: item?.lp,
    name: item?.nazwa,
    unit: item?.jm,
    quantity: item?.ilosc,
    vatRate: item?.stawka_vat,
    price: item?.cena_netto,
    netValue: net,
    vatValue: Math.round((Number(gross) - Number(net)) * 100) / 100,
    grossValue: gross,
  };

  return (
    <tr>
      <td>
        <span data-name="lp">{item?.lp}</span>
      </td>
      {/* <td>
                    <input type="text" name="code" />
                  </td> */}
      <td>
        <span data-name="name">{i?.name}</span>
      </td>
      <td>
        <span data-name="unit">{i?.unit}</span>
      </td>
      <td>
        <span data-name="quantity">{i?.quantity}</span>
      </td>
      <td>
        <span data-name="vatRate">{i?.vatRate}</span>
      </td>
      {/* <td>
                    <input type="number" step="0.01" name="discount" />
                  </td> */}
      <td>
        <span data-name="price">{i?.price}</span>
      </td>
      <td>
        <span data-name="netValue">{i?.netValue}</span>
      </td>
      <td>
        <span data-name="vatValue">{i?.vatValue}</span>
      </td>
      <td>
        <span data-name="grossValue">{i?.grossValue}</span>
      </td>
      <td>
        <input type="text" name="notes" />
      </td>
    </tr>
  );
}
